/*
 * master-bmsm-v2.js
 *
 * Checkout + stock fix for the master-buy-more-save-more-v2 section, Plunge bundle.
 *
 * Why this exists:
 *   The v2 section emits its variant list with {% for variant in product.variants %},
 *   which Liquid caps at 250. The Plunge Perfection Padded Bra bundle has 360 variants
 *   (24 sizes x 5 colors x 3 packs). With ~110 variants missing from the page:
 *     - the section's checkout resolver returns null for upper sizes, and
 *     - the section's own stock filter (combined-layout, setInterval 600ms) both
       mis-disables in-stock upper sizes (38D, 40A-C) AND cannot see out-of-stock
       upper combos.
 *
 * Fix (single source of truth = DATA below, all 360 with live availability):
   1. Rewrite the variant JSON to the full 360 set so the EXISTING section stock
      filter + resolver compute correctly (e.g. Caramel 36D greys out; 40A-C enable).
      No fighting the 600ms interval - we repair its data source instead.
   2. Bind an authoritative capture-phase checkout that resolves from the hardcoded
      map and blocks out-of-stock combos.
 *
 * Scope guard:
 *   Active ONLY for the Plunge bundle handle, so no other product is affected.
 *
 * Precedence:
   Loaded with defer, so it patches the JSON and binds before the inline section
   scripts (which run on DOMContentLoaded) and sets v2CheckoutBound so the inline
   checkout self-suppresses; stopImmediatePropagation() blocks the v3 bubble handler.
 */
(function() {
  var PLUNGE_HANDLE = 'plunge-perfection-padded-bra-bundle';

  /* [size, color, qty, variantId, available] - all 360 (live product exceeds Liquid's 250 cap) */
  var DATA = [
    ["32A","Beige","1 Pack",53442847047994,1],["32A","Beige","2 Packs",53442847080762,1],["32A","Beige","3 Packs",53442847113530,1],
    ["32A","Onyx","1 Pack",53442847146298,1],["32A","Onyx","2 Packs",53442847179066,1],["32A","Onyx","3 Packs",53442847211834,1],
    ["32A","Caramel","1 Pack",53442847244602,1],["32A","Caramel","2 Packs",53442847277370,1],["32A","Caramel","3 Packs",53442847310138,1],
    ["32A","Ivory","1 Pack",53442847342906,1],["32A","Ivory","2 Packs",53442847375674,1],["32A","Ivory","3 Packs",53442847408442,1],
    ["32A","Cocoa","1 Pack",53442847441210,1],["32A","Cocoa","2 Packs",53442847473978,1],["32A","Cocoa","3 Packs",53442847506746,1],
    ["32B","Beige","1 Pack",53442847539514,1],["32B","Beige","2 Packs",53442847572282,1],["32B","Beige","3 Packs",53442847605050,1],
    ["32B","Onyx","1 Pack",53442847637818,1],["32B","Onyx","2 Packs",53442847670586,1],["32B","Onyx","3 Packs",53442847703354,1],
    ["32B","Caramel","1 Pack",53442847736122,1],["32B","Caramel","2 Packs",53442847768890,1],["32B","Caramel","3 Packs",53442847801658,1],
    ["32B","Ivory","1 Pack",53442847834426,1],["32B","Ivory","2 Packs",53442847867194,1],["32B","Ivory","3 Packs",53442847899962,1],
    ["32B","Cocoa","1 Pack",53442847932730,1],["32B","Cocoa","2 Packs",53442847965498,1],["32B","Cocoa","3 Packs",53442847998266,1],
    ["32C","Beige","1 Pack",53442848031034,1],["32C","Beige","2 Packs",53442848063802,1],["32C","Beige","3 Packs",53442848096570,1],
    ["32C","Onyx","1 Pack",53442848129338,1],["32C","Onyx","2 Packs",53442848162106,1],["32C","Onyx","3 Packs",53442848194874,1],
    ["32C","Caramel","1 Pack",53442848227642,1],["32C","Caramel","2 Packs",53442848260410,1],["32C","Caramel","3 Packs",53442848293178,1],
    ["32C","Ivory","1 Pack",53442848325946,1],["32C","Ivory","2 Packs",53442848358714,1],["32C","Ivory","3 Packs",53442848391482,1],
    ["32C","Cocoa","1 Pack",53442848424250,1],["32C","Cocoa","2 Packs",53442848457018,1],["32C","Cocoa","3 Packs",53442848489786,1],
    ["32D","Beige","1 Pack",53442848522554,1],["32D","Beige","2 Packs",53442848555322,1],["32D","Beige","3 Packs",53442848588090,1],
    ["32D","Onyx","1 Pack",53442848620858,1],["32D","Onyx","2 Packs",53442848653626,1],["32D","Onyx","3 Packs",53442848686394,1],
    ["32D","Caramel","1 Pack",53442848719162,1],["32D","Caramel","2 Packs",53442848751930,1],["32D","Caramel","3 Packs",53442848784698,1],
    ["32D","Ivory","1 Pack",53442848817466,1],["32D","Ivory","2 Packs",53442848850234,1],["32D","Ivory","3 Packs",53442848883002,1],
    ["32D","Cocoa","1 Pack",53442848915770,1],["32D","Cocoa","2 Packs",53442848948538,1],["32D","Cocoa","3 Packs",53442848981306,1],
    ["32E","Beige","1 Pack",53442849014074,1],["32E","Beige","2 Packs",53442849046842,1],["32E","Beige","3 Packs",53442849079610,1],
    ["32E","Onyx","1 Pack",53442849112378,1],["32E","Onyx","2 Packs",53442849145146,1],["32E","Onyx","3 Packs",53442849177914,1],
    ["32E","Caramel","1 Pack",53442849210682,1],["32E","Caramel","2 Packs",53442849243450,1],["32E","Caramel","3 Packs",53442849276218,1],
    ["32E","Ivory","1 Pack",53442849308986,1],["32E","Ivory","2 Packs",53442849341754,1],["32E","Ivory","3 Packs",53442849374522,1],
    ["32E","Cocoa","1 Pack",53442849407290,1],["32E","Cocoa","2 Packs",53442849440058,1],["32E","Cocoa","3 Packs",53442849472826,1],
    ["32F","Beige","1 Pack",53442849505594,1],["32F","Beige","2 Packs",53442849538362,1],["32F","Beige","3 Packs",53442849571130,1],
    ["32F","Onyx","1 Pack",53442849603898,1],["32F","Onyx","2 Packs",53442849636666,1],["32F","Onyx","3 Packs",53442849669434,1],
    ["32F","Caramel","1 Pack",53442849702202,1],["32F","Caramel","2 Packs",53442849734970,1],["32F","Caramel","3 Packs",53442849767738,1],
    ["32F","Ivory","1 Pack",53442849800506,1],["32F","Ivory","2 Packs",53442849833274,1],["32F","Ivory","3 Packs",53442849866042,1],
    ["32F","Cocoa","1 Pack",53442849898810,1],["32F","Cocoa","2 Packs",53442849931578,1],["32F","Cocoa","3 Packs",53442849964346,1],
    ["34A","Beige","1 Pack",53442849997114,1],["34A","Beige","2 Packs",53442850029882,1],["34A","Beige","3 Packs",53442850062650,1],
    ["34A","Onyx","1 Pack",53442850095418,1],["34A","Onyx","2 Packs",53442850128186,1],["34A","Onyx","3 Packs",53442850160954,1],
    ["34A","Caramel","1 Pack",53442850193722,1],["34A","Caramel","2 Packs",53442850226490,1],["34A","Caramel","3 Packs",53442850259258,1],
    ["34A","Ivory","1 Pack",53442850292026,1],["34A","Ivory","2 Packs",53442850324794,1],["34A","Ivory","3 Packs",53442850357562,1],
    ["34A","Cocoa","1 Pack",53442850390330,1],["34A","Cocoa","2 Packs",53442850423098,1],["34A","Cocoa","3 Packs",53442850455866,1],
    ["34B","Beige","1 Pack",53442850488634,1],["34B","Beige","2 Packs",53442850521402,1],["34B","Beige","3 Packs",53442850554170,1],
    ["34B","Onyx","1 Pack",53442850586938,1],["34B","Onyx","2 Packs",53442850619706,1],["34B","Onyx","3 Packs",53442850652474,1],
    ["34B","Caramel","1 Pack",53442850685242,1],["34B","Caramel","2 Packs",53442850718010,1],["34B","Caramel","3 Packs",53442850750778,1],
    ["34B","Ivory","1 Pack",53442850783546,1],["34B","Ivory","2 Packs",53442850816314,1],["34B","Ivory","3 Packs",53442850849082,1],
    ["34B","Cocoa","1 Pack",53442850881850,1],["34B","Cocoa","2 Packs",53442850914618,1],["34B","Cocoa","3 Packs",53442850947386,1],
    ["34C","Beige","1 Pack",53442850980154,1],["34C","Beige","2 Packs",53442851012922,1],["34C","Beige","3 Packs",53442851045690,1],
    ["34C","Onyx","1 Pack",53442851078458,1],["34C","Onyx","2 Packs",53442851111226,1],["34C","Onyx","3 Packs",53442851143994,1],
    ["34C","Caramel","1 Pack",53442851176762,1],["34C","Caramel","2 Packs",53442851209530,1],["34C","Caramel","3 Packs",53442851242298,1],
    ["34C","Ivory","1 Pack",53442851275066,1],["34C","Ivory","2 Packs",53442851307834,1],["34C","Ivory","3 Packs",53442851340602,1],
    ["34C","Cocoa","1 Pack",53442851373370,1],["34C","Cocoa","2 Packs",53442851406138,1],["34C","Cocoa","3 Packs",53442851438906,1],
    ["34D","Beige","1 Pack",53442851471674,1],["34D","Beige","2 Packs",53442851504442,1],["34D","Beige","3 Packs",53442851537210,1],
    ["34D","Onyx","1 Pack",53442851569978,1],["34D","Onyx","2 Packs",53442851602746,1],["34D","Onyx","3 Packs",53442851635514,1],
    ["34D","Caramel","1 Pack",53442851668282,1],["34D","Caramel","2 Packs",53442851701050,1],["34D","Caramel","3 Packs",53442851733818,1],
    ["34D","Ivory","1 Pack",53442851766586,1],["34D","Ivory","2 Packs",53442851799354,1],["34D","Ivory","3 Packs",53442851832122,1],
    ["34D","Cocoa","1 Pack",53442851864890,1],["34D","Cocoa","2 Packs",53442851897658,1],["34D","Cocoa","3 Packs",53442851930426,1],
    ["34E","Beige","1 Pack",53442851963194,1],["34E","Beige","2 Packs",53442851995962,1],["34E","Beige","3 Packs",53442852028730,1],
    ["34E","Onyx","1 Pack",53442852061498,1],["34E","Onyx","2 Packs",53442852094266,1],["34E","Onyx","3 Packs",53442852127034,1],
    ["34E","Caramel","1 Pack",53442852159802,1],["34E","Caramel","2 Packs",53442852192570,1],["34E","Caramel","3 Packs",53442852225338,1],
    ["34E","Ivory","1 Pack",53442852258106,1],["34E","Ivory","2 Packs",53442852290874,1],["34E","Ivory","3 Packs",53442852323642,1],
    ["34E","Cocoa","1 Pack",53442852356410,1],["34E","Cocoa","2 Packs",53442852389178,1],["34E","Cocoa","3 Packs",53442852421946,1],
    ["34F","Beige","1 Pack",53442852454714,1],["34F","Beige","2 Packs",53442852487482,1],["34F","Beige","3 Packs",53442852520250,1],
    ["34F","Onyx","1 Pack",53442852553018,1],["34F","Onyx","2 Packs",53442852585786,1],["34F","Onyx","3 Packs",53442852618554,1],
    ["34F","Caramel","1 Pack",53442852651322,1],["34F","Caramel","2 Packs",53442852684090,1],["34F","Caramel","3 Packs",53442852716858,1],
    ["34F","Ivory","1 Pack",53442852749626,1],["34F","Ivory","2 Packs",53442852782394,1],["34F","Ivory","3 Packs",53442852815162,1],
    ["34F","Cocoa","1 Pack",53442852847930,1],["34F","Cocoa","2 Packs",53442852880698,1],["34F","Cocoa","3 Packs",53442852913466,1],
    ["36A","Beige","1 Pack",53442852946234,1],["36A","Beige","2 Packs",53442852979002,1],["36A","Beige","3 Packs",53442853011770,1],
    ["36A","Onyx","1 Pack",53442853044538,1],["36A","Onyx","2 Packs",53442853077306,1],["36A","Onyx","3 Packs",53442853110074,1],
    ["36A","Caramel","1 Pack",53442853142842,1],["36A","Caramel","2 Packs",53442853175610,1],["36A","Caramel","3 Packs",53442853208378,1],
    ["36A","Ivory","1 Pack",53442853241146,1],["36A","Ivory","2 Packs",53442853273914,1],["36A","Ivory","3 Packs",53442853306682,1],
    ["36A","Cocoa","1 Pack",53442853339450,1],["36A","Cocoa","2 Packs",53442853372218,1],["36A","Cocoa","3 Packs",53442853404986,1],
    ["36B","Beige","1 Pack",53442853437754,1],["36B","Beige","2 Packs",53442853470522,1],["36B","Beige","3 Packs",53442853503290,1],
    ["36B","Onyx","1 Pack",53442853536058,1],["36B","Onyx","2 Packs",53442853568826,1],["36B","Onyx","3 Packs",53442853601594,1],
    ["36B","Caramel","1 Pack",53442853634362,1],["36B","Caramel","2 Packs",53442853667130,1],["36B","Caramel","3 Packs",53442853699898,1],
    ["36B","Ivory","1 Pack",53442853732666,1],["36B","Ivory","2 Packs",53442853765434,1],["36B","Ivory","3 Packs",53442853798202,1],
    ["36B","Cocoa","1 Pack",53442853830970,1],["36B","Cocoa","2 Packs",53442853863738,1],["36B","Cocoa","3 Packs",53442853896506,1],
    ["36C","Beige","1 Pack",53442853929274,1],["36C","Beige","2 Packs",53442853962042,1],["36C","Beige","3 Packs",53442853994810,1],
    ["36C","Onyx","1 Pack",53442854027578,1],["36C","Onyx","2 Packs",53442854060346,1],["36C","Onyx","3 Packs",53442854093114,1],
    ["36C","Caramel","1 Pack",53442854125882,1],["36C","Caramel","2 Packs",53442854158650,1],["36C","Caramel","3 Packs",53442854191418,1],
    ["36C","Ivory","1 Pack",53442854224186,1],["36C","Ivory","2 Packs",53442854256954,1],["36C","Ivory","3 Packs",53442854289722,1],
    ["36C","Cocoa","1 Pack",53442854322490,1],["36C","Cocoa","2 Packs",53442854355258,1],["36C","Cocoa","3 Packs",53442854388026,1],
    ["36D","Beige","1 Pack",53442854420794,1],["36D","Beige","2 Packs",53442854453562,1],["36D","Beige","3 Packs",53442854486330,1],
    ["36D","Onyx","1 Pack",53442854519098,1],["36D","Onyx","2 Packs",53442854551866,1],["36D","Onyx","3 Packs",53442854584634,1],
    ["36D","Caramel","1 Pack",53442854617402,0],["36D","Caramel","2 Packs",53442854650170,0],["36D","Caramel","3 Packs",53442854682938,0],
    ["36D","Ivory","1 Pack",53442854715706,1],["36D","Ivory","2 Packs",53442854748474,1],["36D","Ivory","3 Packs",53442854781242,1],
    ["36D","Cocoa","1 Pack",53442854814010,1],["36D","Cocoa","2 Packs",53442854846778,1],["36D","Cocoa","3 Packs",53442854879546,1],
    ["36E","Beige","1 Pack",53442854912314,1],["36E","Beige","2 Packs",53442854945082,1],["36E","Beige","3 Packs",53442854977850,1],
    ["36E","Onyx","1 Pack",53442855010618,1],["36E","Onyx","2 Packs",53442855043386,1],["36E","Onyx","3 Packs",53442855076154,1],
    ["36E","Caramel","1 Pack",53442855108922,1],["36E","Caramel","2 Packs",53442855141690,1],["36E","Caramel","3 Packs",53442855174458,1],
    ["36E","Ivory","1 Pack",53442855207226,1],["36E","Ivory","2 Packs",53442855239994,1],["36E","Ivory","3 Packs",53442855272762,1],
    ["36E","Cocoa","1 Pack",53442855305530,1],["36E","Cocoa","2 Packs",53442855338298,1],["36E","Cocoa","3 Packs",53442855371066,1],
    ["38A","Beige","1 Pack",53442855403834,1],["38A","Beige","2 Packs",53442855436602,1],["38A","Beige","3 Packs",53442855469370,1],
    ["38A","Onyx","1 Pack",53442855502138,1],["38A","Onyx","2 Packs",53442855534906,1],["38A","Onyx","3 Packs",53442855567674,1],
    ["38A","Caramel","1 Pack",53442855600442,1],["38A","Caramel","2 Packs",53442855633210,1],["38A","Caramel","3 Packs",53442855665978,1],
    ["38A","Ivory","1 Pack",53442855698746,1],["38A","Ivory","2 Packs",53442855731514,1],["38A","Ivory","3 Packs",53442855764282,1],
    ["38A","Cocoa","1 Pack",53442855797050,1],["38A","Cocoa","2 Packs",53442855829818,1],["38A","Cocoa","3 Packs",53442855862586,1],
    ["38B","Beige","1 Pack",53442855895354,1],["38B","Beige","2 Packs",53442855928122,1],["38B","Beige","3 Packs",53442855960890,1],
    ["38B","Onyx","1 Pack",53442855993658,1],["38B","Onyx","2 Packs",53442856026426,1],["38B","Onyx","3 Packs",53442856059194,1],
    ["38B","Caramel","1 Pack",53442856091962,1],["38B","Caramel","2 Packs",53442856124730,1],["38B","Caramel","3 Packs",53442856157498,1],
    ["38B","Ivory","1 Pack",53442856190266,1],["38B","Ivory","2 Packs",53442856223034,1],["38B","Ivory","3 Packs",53442856255802,1],
    ["38B","Cocoa","1 Pack",53442856288570,1],["38B","Cocoa","2 Packs",53442856321338,1],["38B","Cocoa","3 Packs",53442856354106,1],
    ["38C","Beige","1 Pack",53442856386874,1],["38C","Beige","2 Packs",53442856419642,1],["38C","Beige","3 Packs",53442856452410,1],
    ["38C","Onyx","1 Pack",53442856485178,1],["38C","Onyx","2 Packs",53442856517946,1],["38C","Onyx","3 Packs",53442856550714,1],
    ["38C","Caramel","1 Pack",53442856583482,1],["38C","Caramel","2 Packs",53442856616250,1],["38C","Caramel","3 Packs",53442856649018,1],
    ["38C","Ivory","1 Pack",53442856681786,1],["38C","Ivory","2 Packs",53442856714554,1],["38C","Ivory","3 Packs",53442856747322,1],
    ["38C","Cocoa","1 Pack",53442856780090,1],["38C","Cocoa","2 Packs",53442856812858,1],["38C","Cocoa","3 Packs",53442856845626,1],
    ["38D","Beige","1 Pack",53442856878394,1],["38D","Beige","2 Packs",53442856911162,1],["38D","Beige","3 Packs",53442856943930,1],
    ["38D","Onyx","1 Pack",53442856976698,1],["38D","Onyx","2 Packs",53442857009466,1],["38D","Onyx","3 Packs",53442857042234,1],
    ["38D","Caramel","1 Pack",53442857075002,1],["38D","Caramel","2 Packs",53442857107770,1],["38D","Caramel","3 Packs",53442857140538,1],
    ["38D","Ivory","1 Pack",53442857173306,1],["38D","Ivory","2 Packs",53442857206074,1],["38D","Ivory","3 Packs",53442857238842,1],
    ["38D","Cocoa","1 Pack",53442857271610,1],["38D","Cocoa","2 Packs",53442857304378,1],["38D","Cocoa","3 Packs",53442857337146,1],
    ["40A","Beige","1 Pack",53442857369914,1],["40A","Beige","2 Packs",53442857402682,1],["40A","Beige","3 Packs",53442857435450,1],
    ["40A","Onyx","1 Pack",53442857468218,1],["40A","Onyx","2 Packs",53442857500986,1],["40A","Onyx","3 Packs",53442857533754,1],
    ["40A","Caramel","1 Pack",53442857566522,1],["40A","Caramel","2 Packs",53442857599290,1],["40A","Caramel","3 Packs",53442857632058,1],
    ["40A","Ivory","1 Pack",53442857664826,1],["40A","Ivory","2 Packs",53442857697594,1],["40A","Ivory","3 Packs",53442857730362,1],
    ["40A","Cocoa","1 Pack",53442857763130,1],["40A","Cocoa","2 Packs",53442857795898,1],["40A","Cocoa","3 Packs",53442857828666,1],
    ["40B","Beige","1 Pack",53442857861434,1],["40B","Beige","2 Packs",53442857894202,1],["40B","Beige","3 Packs",53442857926970,1],
    ["40B","Onyx","1 Pack",53442857959738,1],["40B","Onyx","2 Packs",53442857992506,1],["40B","Onyx","3 Packs",53442858025274,1],
    ["40B","Caramel","1 Pack",53442858058042,1],["40B","Caramel","2 Packs",53442858090810,1],["40B","Caramel","3 Packs",53442858123578,1],
    ["40B","Ivory","1 Pack",53442858156346,1],["40B","Ivory","2 Packs",53442858189114,1],["40B","Ivory","3 Packs",53442858221882,1],
    ["40B","Cocoa","1 Pack",53442858254650,0],["40B","Cocoa","2 Packs",53442858287418,0],["40B","Cocoa","3 Packs",53442858320186,0],
    ["40C","Beige","1 Pack",53442858352954,1],["40C","Beige","2 Packs",53442858385722,1],["40C","Beige","3 Packs",53442858418490,1],
    ["40C","Onyx","1 Pack",53442858451258,1],["40C","Onyx","2 Packs",53442858484026,1],["40C","Onyx","3 Packs",53442858516794,1],
    ["40C","Caramel","1 Pack",53442858549562,1],["40C","Caramel","2 Packs",53442858582330,1],["40C","Caramel","3 Packs",53442858615098,1],
    ["40C","Ivory","1 Pack",53442858647866,1],["40C","Ivory","2 Packs",53442858680634,1],["40C","Ivory","3 Packs",53442858713402,1],
    ["40C","Cocoa","1 Pack",53442858746170,0],["40C","Cocoa","2 Packs",53442858778938,0],["40C","Cocoa","3 Packs",53442858811706,0]
  ];

  /* Derive lookups once from the single DATA source. */
  var variantMap = {};   // "size|color|qty" -> variant id
  var availableMap = {}; // "size|color|qty" -> true when purchasable
  var fullVariants = []; // shape the section JSON expects: { id, options, qty }
  DATA.forEach(function(row) {
    var key = row[0] + '|' + row[1] + '|' + row[2];
    variantMap[key] = row[3];
    availableMap[key] = row[4] === 1;
    fullVariants.push({ id: row[3], options: [row[0], row[1], row[2]], qty: row[4] ? 1 : 0 });
  });
  var fullVariantsJson = JSON.stringify(fullVariants);

  /*
    Replace the section's truncated (250) variant JSON with the full 360 set.
    The section own stock filter + checkout resolver read this tag, so repairing
    it makes their existing logic correct for every size - including out-of-stock
    combos (Caramel 36D) and the in-stock upper sizes the cap had hidden.
    Runs during defer (before the inline scripts parse it on DOMContentLoaded).
  */
  function patchVariantJson(section) {
    var sectionId = section.dataset.sectionId;
    if (!sectionId) return;
    var dataEl = document.getElementById('master-bmsm-product-variants-' + sectionId);
    if (!dataEl || dataEl.dataset.v2Full === '1') return;
    dataEl.textContent = fullVariantsJson;
    dataEl.dataset.v2Full = '1';
  }

  function getSelectedColor(section) {
    var radio = section.querySelector('fieldset.is-style-color input[type="radio"]:checked');
    if (radio && radio.value) return radio.value;
    var label = section.querySelector('fieldset.is-style-color [update-value]');
    return label ? label.textContent.trim() : '';
  }

  function getSelectedSize(section) {
    var sizeInput = section.querySelector('input[is-value][name="option1"]');
    return sizeInput ? sizeInput.value : '';
  }

  function qtyLabel(qty) {
    return qty === 1 ? '1 Pack' : qty + ' Packs';
  }

  function bindCheckout(section) {
    var checkoutBtn = section.querySelector('[id^="master-bmsm-checkout-btn-"]');
    if (!checkoutBtn) return;
    if (checkoutBtn.dataset.v2CheckoutBound === '1') return;
    checkoutBtn.dataset.v2CheckoutBound = '1';

    var sectionId = checkoutBtn.id.replace('master-bmsm-checkout-btn-', '');
    var validation = document.getElementById('master-bmsm-validation-' + sectionId);
    var label = checkoutBtn.querySelector('.hdt-btn-atc_text');

    function isSizeSelected() {
      var sizeBtn = section.querySelector('fieldset.is-style-size .hdt-select');
      if (!sizeBtn) return true;
      var text = sizeBtn.textContent.trim().toLowerCase();
      if (!text || text === 'select size') return false;
      return true;
    }

    function showSizeError() {
      checkoutBtn.classList.add('error');
      if (validation) validation.classList.add('show');
      setTimeout(function() {
        checkoutBtn.classList.remove('error');
        if (validation) validation.classList.remove('show');
      }, 3000);
    }

    function resolveVariantId() {
      var size = getSelectedSize(section);
      var color = getSelectedColor(section);
      if (!size || !color) return 0;

      var activeRow = section.querySelector('.hdt-master-bmsm-bundle-row.active');
      var bundleQty = activeRow ? parseInt(activeRow.getAttribute('data-qty'), 10) : 1;
      if (!bundleQty || isNaN(bundleQty) || bundleQty < 1) bundleQty = 1;

      var key = size + '|' + color + '|' + qtyLabel(bundleQty);
      // Block out-of-stock combos (e.g. Caramel 36D).
      if (availableMap[key] === false) return 0;
      return variantMap[key] || 0;
    }

    checkoutBtn.addEventListener('click', function(e) {
      if (checkoutBtn.getAttribute('aria-busy') === 'true') return;

      if (!isSizeSelected()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showSizeError();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      var variantId = resolveVariantId();
      if (!variantId) {
        showSizeError();
        return;
      }

      /*
        The section's own handler appends the tier's free gift, but this file
        calls stopImmediatePropagation before it ever runs, so the gift has to
        be added here too or the Buy 3 tile silently ships without it.
      */
      var giftRow = section.querySelector('.hdt-master-bmsm-bundle-row.active');
      var giftVariantId = giftRow ? giftRow.getAttribute('data-gift-variant') : null;
      var cartItems = [{ id: variantId, quantity: 1 }];

      if (giftVariantId) {
        cartItems.push({ id: parseInt(giftVariantId, 10), quantity: 1 });
      }

      checkoutBtn.setAttribute('aria-busy', 'true');
      if (label) label.textContent = 'PROCESSING...';

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: cartItems })
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.items || data.id) {
            window.location.href = '/checkout';
          } else {
            checkoutBtn.removeAttribute('aria-busy');
            if (label) label.textContent = 'CHECKOUT';
          }
        })
        .catch(function() {
          checkoutBtn.removeAttribute('aria-busy');
          if (label) label.textContent = 'CHECKOUT';
        });
    }, true);
  }

  function initAll() {
    document.querySelectorAll('.hdt-master-buy-more-save-more-section').forEach(function(section) {
      // Only the Plunge bundle needs this; leave every other product on the stock logic.
      if (section.dataset.productHandle !== PLUNGE_HANDLE) return;
      patchVariantJson(section);
      bindCheckout(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Re-apply after a theme-editor section reload. */
  document.addEventListener('shopify:section:load', initAll);
})();
